import React from 'react'

export const SanitizeRichText = ({ html }) => {
  if (!html) return <span>N/A</span>

  return <span>{html?.replace(/<.*?>/g, '')?.slice(0, 80) + ' ...' ?? 'N/A'}</span>
}
